import React, {useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from "../../../../utils/CommonUtil";
import StringUtil from "../../../../utils/StringUtil";
import UIUtils from "../../../../utils/UIUtils";
import DateUtil from "../../../../utils/DateUtil";
function ContentsContainer() {
	//테스트용 서버 url
	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();


	const [bizCd,setBizCd] = useState('');
	const [bizNo,setBizNo] = useState('');
	const [bizNm,setBizNm] = useState('');
	const [donNo,setDonNo] = useState('');
	const [donNoFmt,setDonNoFmt] = useState('');
	const [corpNm,setCorpNm] = useState('');
	const [receNo,setReceNo] = useState('');
	const [receSts,setReceSts] = useState('');
	const [publishType,setPublishType] = useState('1');
	const [donDateModYn,setDonDateModYn] = useState('N');
	const [personNm,setPersonNm] = useState('');
	const [deptNm,setDeptNm] = useState('');
	const [donReqDate,setDonReqDate] = useState('');
	const [donReqAmt,setDonReqAmt] = useState('');
	const [bankCd,setBankCd] = useState('');
	const [acctNoDes,setAcctNoDes] = useState('');
	const [receAmt,setReceAmt] = useState('');
	const [lastReceDate,setLastReceDate] = useState('');
	const [REC2, setREC2] = useState<any>([]);
	const [REC3, setREC3] = useState<any>([]);
	const [receNoList, setReceNoList] = useState<any>([]);
	const [totalIn, setTotalIn] = useState<any>([]);

	const [amtList, setAmtList] = React.useState<any[]>([{ DON_RECE_AMT : '', num : 0 , checked : false },{ DON_RECE_AMT : '', num : 1 , checked : false }]);
	const [nextNum,setNextNum] = useState(2); //amtList 고유 key
	const [totalAmt, setTotalAmt] = useState(0); //금액 총액
	const [isAllChk,setIsAllChk] = useState(false); //전체체크 여부
	const [modDonDate,setModDonDate] = useState(new Date());
	function changeVal(val, type, index){
		if(type == 'rec3'){
			let newList = [...REC3];
			if(Number(newList[index].REMAIN_AMT) < Number(val)){
				UIUtils.alert('발급가능금액을 초과할수없습니다.');
				return
			}else{
				newList[index].USE_AMT = val;
				setREC3(newList);

				let sum = newList.reduce((total, amt) => {
					return Number(amt.USE_AMT) + total
				}, 0);

				setTotalIn(sum);
			}

		}else{
			let newList = [...amtList];

			if(type == 'amt'){
				newList[index].DON_RECE_AMT = val;
			}else if(type == 'checked'){
				newList[index].checked = val;
			}

			setAmtList(newList);

			if(type == 'amt'){
				let sum = newList.reduce((total, amt) => {
					return Number(amt.DON_RECE_AMT) + total
				}, 0);
				setTotalAmt(sum);
			}
		}

		console.log('type : ' + type)
		console.log('val : ' + val)
	}

	function addList(){
		const nextAmt = amtList.concat({
			DON_RECE_AMT : '', num : 0 , checked : false
		});
		setNextNum(nextNum + 1);
		setAmtList(nextAmt);
	}

	function deleteList(){
		let newList = amtList.filter(function(data) {
			return !data.checked
		});

		if(newList.length != 0){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.DON_RECE_AMT) + total
			}, 0);
			setTotalAmt(sum); //삭제 후 토탈 재계산
			setAmtList(newList);
		}else{
			//전체 삭제시 초기화
			newList = [{ DON_RECE_AMT : '', num : 0 , checked : false },{ DON_RECE_AMT : '', num : 1 , checked : false }];
			setAmtList(newList);
			setTotalAmt(0);
			setIsAllChk(false);
			setNextNum(1);
		}
	}

	function isChecked(element)  {
		if(element.checked == false)  {
			return true;
		}
	}

	const checkBoxHandler = (e) => {
		//체크박스 제어
		if(e.target.name === 'ch-all'){
			setIsAllChk(e.target.checked);
		} else {
			let numReg = /[^0-9]/g;
			let name = e.target.name;
			let index = name.replace(numReg, '');
			//값변경 제어
			changeVal(e.target.checked, 'checked', index);
		}

		//전체체크 확인
		if(e.target.name != 'ch-all'){
			let isAll = false;

			//false가 없는지 체크
			if(amtList.find(isChecked) == undefined){
				isAll = true;
			}
			setIsAllChk(isAll);

		}else{
			let newList = [...amtList];
			let allCheckBol = e.target.checked;
			newList = newList.map(e => {
				e.checked = allCheckBol;
				return e;
			});
			setAmtList(newList);
		}
	};


	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let val = event.target.value;
		//여기
		setPublishType(val);
	};

	const handleOptionChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
		let val = event.target.value;
		//여기
		setDonDateModYn(val);
	};

	function backPage(){
		let dataToSend = {vDON_NO : donNo,vAll_PARAM:receivedData.vAll_PARAM };
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm3300',
			state: { data: dataToSend }
		});
	}

	async function saveRece(){
		//receAmt 발급된 금액임 0이 아니면 무조건 발급된거임
		if(Number(receAmt) != 0){
			await UIUtils.alert('이미 영수증이 발급 되어있습니다.');
			return;
		}

		let compareDate = '';
		for(let i = 0; i < REC3.length; i++){
			if(REC3[i].USE_AMT != '0' && REC3[i].USE_AMT != ''){
				if(compareDate == '') compareDate = REC3[i].ACCT_TXDAY
				else{
					if(compareDate != REC3[i].ACCT_TXDAY){
						await UIUtils.alert('선택하신 입금내역의 입금일이 동일하지 않습니다.');
						return;
					}
				}
			}
		}

		if(publishType == '2'){
			let listTotal = amtList.reduce((total, amt) => {
				return Number(amt.DON_RECE_AMT) + total
			}, 0);
			let amtChk = true;
			// @ts-ignore
			if(( Number(listTotal) == Number(donReqAmt) && Number(listTotal) == Number(totalIn) && Number(donReqAmt) == Number(totalIn) )) amtChk = false;
			if(amtChk){
				await UIUtils.alert('다건으로 발행시 기부금 분할금액의 합과 출연신청금액, 발급금액의 합이 모두 동일해야 합니다.');
				return;
			}
		}else{
			if(Number(totalIn) != Number(donReqAmt)){
				await UIUtils.alert('발급금액의 합은 출연신청금액과 동일해야 합니다.');
				return;
			}
		}


		if(await UIUtils.confirm('저장하시겠습니까?')){


			let param = {};

			let fullDate = compareDate.substring(2,4);
			let month = compareDate.substring(4,6)
			let day = compareDate.substring(6,8);
			let modDt = DateUtil.toDateFormat(modDonDate, "YYYYMMDD");
			fullDate = fullDate+month+day;


			param = {
				'BIZ_CD' : bizCd,
				'BIZ_NO' : bizNo,
				'ACC_LIST' : REC3,
				'DON_RECE_AMT' : Number(donReqAmt), //단건일때 출연신청금 전체금액
				'DON_NO' : donNo,
				'PUBLISH_TYPE' : publishType,
				'RECE_AMT_LIST' : amtList,
				'DON_RECE_YN' : 'Y',
				'DON_RECE_STS' : '1',
				'YEAR' : fullDate,
				'DON_DATE_MOD_YN' : donDateModYn,
				'MOD_DON_DATE' : modDt
			};

			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'adm_3301',
				data: param
			})

			UIUtils.alert('정상처리되었습니다.').then();
			let dataToSend = {};
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
				pathname: './adm3200',
				state: { data: dataToSend }
			});

		}






	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}


	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	async function initCall(){

		let param = {
			"DON_NO": receivedData.vDON_NO
		};

		const response:any = await CommonUtil.execute({
			url:'adm_3300',
			data: param
		})

		const result = response;
		console.log(result)
		setReceSts(result.RECE_STS);
		setDonNo(result.DON_NO);
		setDonNoFmt((result.DON_NO).substr(0, 3)+"-"+(result.DON_NO).substr(3,4)+"-"+(result.DON_NO).substr(7,3));
		setBizNo(result.BIZ_NO);
		setBizCd(result.BIZ_CD);
		setCorpNm(result.CORP_NM);
		setBizNm(result.BIZ_NM);
		setDonReqDate(result.DON_REQ_DATE);
		setDonReqAmt(result.DON_REQ_AMT);
		//setBankCd(result.BANK_CD);
		setBankCd('하나은행');
		setAcctNoDes(result.ACCT_NO_DES);
		setReceAmt(result.RECE_AMT);
		setLastReceDate(result.LAST_RECE_DATE);
		setReceNo(result.RECE_NO);
		setDeptNm(result.DEPT_NM);
		setPersonNm(result.PERSON_NM);
		setREC2(result.REC2);

		setREC3(
			result.REC3.map(data => ({
				...data, USE_AMT : '0'
			}))
		);
		//setCorpInfo(result);
		setReceNoList(result.RECE_NO.split(','))

		/*let sum = result.REC3.reduce((total, amt) => {
			return Number(amt.TX_AMT) + total
		}, 0);*/
		//setTotalIn(result.DON_REQ_AMT);


		// @ts-ignore
		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}
	};

	React.useEffect(() => {
		initCall();
	}, [])//effect

	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<Breadcrumb gnbIdx={2} lnbD1Idx={1} />
				<main className="fww-main">
					<h1 className="tx tx-hd2">기부금영수증 등록</h1>
					<h3 className="section-title mb15">출연정보</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출연번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={donNoFmt} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연기업</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연사업</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md ta-right w100p'} value={bizNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연신청일</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={dateToStr(donReqDate)} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">출연신청금액(원)</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(donReqAmt)) || "0"} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">입금은행</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={bankCd} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">계좌번호</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md ta-right w100p'} value={acctNoDes} placeholder={''} readOnly={true} />
								</div>
							</div>

						</div>
					</form>
					<h3 className="section-title mb15">출연기업 가상계좌 입금내역</h3>
					<div className="fo fo-col2 mb">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">발급금액의 합(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(totalIn)) || "0"} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</div>
					<section className="fund-section">
						<div>
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col />
										<col />
										<col />
										<col />
										<col />
										<col width="250px" />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">NO</th>
										<th scope="col">거래일시</th>
										<th scope="col">계좌구분</th>
										<th scope="col">가상계좌</th>
										<th scope="col">입금액(원)</th>
										<th scope="col">발급가능금액(원)</th>
										<th scope="col">발급금액(원)</th>
										<th scope="col">입금의뢰인</th>
									</tr>
									</thead>
									<tbody>
									{REC3 != null? REC3.map((rec, index) => (
											<tr key={index}>
												<td>{index+1}</td>
												<td>{rec.ACCT_DATE}</td>
												<td>{'출연계좌'}</td>
												<td>{rec.VACCT_NO}</td>
												<td>{StringUtil.formatNumber(Number(rec.TX_AMT)) || "0"}</td>
												<td>{StringUtil.formatNumber(Number(rec.REMAIN_AMT)) || "0"}</td>
												<td>
													<UIInput className={'tf tf-md ta-right w100p'}
																 value={StringUtil.formatNumber(Number(rec.USE_AMT)) || ""}
																 valueChanged={(value) => {
																	 let tmpVal = value.replace(/[^0-9]/g, "");
																	 changeVal(tmpVal, 'rec3', index);
																 }}
																 placeholder={'금액을 입력하세요(숫자만입력)'}
														/>
												</td>
												<td>{rec.JEOKYO}</td>
											</tr>
										))
									: "데이터가 없습니다."}
									</tbody>
								</table>
							</div>
						</div>
					</section>
					<div className="fo fo-col2 mb">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">영수증 발급 방법</p>
								<div className="fo-value">
									<div className="hz-root hz-gap15 h36">
										<label htmlFor="rd-1-1" className="ip-rd-label">
											<input name="rd-1" id="rd-1-1" className="ip-rd" type="radio" value='1' checked={publishType == '1'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">단건으로 발급</span>
										</label>
										<label htmlFor="rd-1-2" className="ip-rd-label">
											<input name="rd-1" id="rd-1-2" className="ip-rd" type="radio" value='2' checked={publishType == '2'} onChange={handleOptionChange}/>
											<span className="check"></span>
											<span className="txt">다건으로 발급</span>
										</label>
									</div>
								</div>
								<p className="fo-key">기부금영수증 발급 입금지정일</p>
								<div className="fo-value">
									<div className="hz-root hz-gap15 h36">
										<label htmlFor="rd-2-1" className="ip-rd-label">
											<input name="rd-2" id="rd-2-1" className="ip-rd" type="radio" value='Y' checked={donDateModYn == 'Y'} onChange={handleOptionChange1}/>
											<span className="check"></span>
											<span className="txt">사용</span>
										</label>
										<label htmlFor="rd-2-2" className="ip-rd-label">
											<input name="rd-2" id="rd-2-2" className="ip-rd" type="radio" value='N' checked={donDateModYn == 'N'} onChange={handleOptionChange1}/>
											<span className="check"></span>
											<span className="txt">미사용</span>
										</label>
										<label>
											{donDateModYn == 'Y' &&
												<UIDatePicker className="hz-item" value={modDonDate} valueChanged={(value) => setModDonDate(value)}/>
											}
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					{publishType == '2' &&
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap10 hz-item">
								<h3 className="section-title">분할 내역</h3>
							</div>
							<div className="hz-root hz-gap5">
								<Button color='pri-o' size="sm" onClick={addList}>행추가</Button>
								<Button color='gray-o' size="sm" onClick={deleteList}>행삭제</Button>
							</div>
						</div>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px" />
										<col width="60px" />
										<col />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">NO</th>
										<th>
											<label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
												<input id="ch-all" className="ip-ch" type="checkbox" name={'ch-all'} checked={isAllChk} onChange={(e) => checkBoxHandler(e)}/>
												<span className="check"></span>
											</label>
										</th>
										<th scope="col">금액</th>
									</tr>
									</thead>
									<tbody>
									{amtList.map((amt, idx) => (
										<tr key={idx}>
											<td scope="col">{idx+1}</td>
											<td>
												<label htmlFor={'ch-t1'+idx} className="hz-item ip-ch-label ip-ch-18">
													<input id={'ch-t1'+idx} className="ip-ch" name={'isChk'+idx} type="checkbox" checked={amt.checked} onChange={(e) => checkBoxHandler(e)} />
													<span className="check"></span>
												</label>
											</td>
											<td>
												<div className="hz-root hz-gap5 w100p">
													<div className="tf-unit hz-item hz-fg">
														<UIInput className={'tf tf-md ta-right'}
																 value={StringUtil.formatNumber(Number(amt.DON_RECE_AMT)) || ""}
																 valueChanged={(value) => {
																	 let tmpVal = value.replace(/[^0-9]/g, "");
																	 changeVal(tmpVal, 'amt', idx);
																 }}
																 placeholder={'금액을 입력하세요(숫자만입력)'}
														/>
														<span className="u">원</span>
													</div>
												</div>
											</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
							<div className="tb-total">
								<div className="tb-total-items">분할금액의 합(원)</div>
								<div className="tb-total-items">
									<div className="fund-form-items tf-unit">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totalAmt)) || "0"} placeholder={''}  readOnly={true}/>
										<span className="u">원</span>
									</div>
									<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(totalAmt + "") ?
										StringUtil.numKorPattern(totalAmt) + " 원" : "원"})</span></p>
								</div>
							</div>
						</form>
					</section>
					}
					<div className="hz-root hz-right hz-gap5 mt10">
						<Button color="gray-o" size="sm" onClick={() => backPage()}>취소</Button>
						<Button color="pri-o" size="sm" onClick={() => saveRece()}>저장</Button>
					</div>
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;